<tile-ipe-gauge-sub-component
    class="cursor-hand"
    [tileData]="tileData"
    [hasTileAdminOption]="tileConfig?.hasTileAdminAccess$ | async"
    [dateStart]="tileConfig.period?.start"
    [dateEnd]="tileConfig.period?.end"
    (edited)="onEdit($event)"
    (deleted)="onDelete()"
    (click)="navigateToTileHistory()"
/>
